import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function SubjectsPage() {
  return <InstituteCrudPage config={entityConfigs['subjects']} />;
}
